import { Reducer } from "redux";

import {
    ARTICLE_PHOTO_FETCH_FAILURE,
    ARTICLE_PHOTO_FETCH_REQUEST,
    ARTICLE_PHOTO_FETCH_SUCCESS,
    ArticlePhotoFetchFailureAction,
    ArticlePhotoFetchRequestAction,
    ArticlePhotoFetchSuccessAction,
} from "@/mk2/apps/wiki/containers/ArticlePhoto/ArticlePhoto.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";
import { WikiArticleEntity, WikiArticleSchema } from "@/mk2/schemas";
import { getDenormalizedEntity } from "@/mk2/selectors";

export interface ArticlePhotosState {
    loadingState: LoadingState;
    errorMessage: string;
    articleId: number | null;
    articlePhotoIds: number[];
}

export const initialArticlePhotosState: ArticlePhotosState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
    articleId: null,
    articlePhotoIds: [],
};

export interface ArticlesPhotosState {
    [key: string]: ArticlePhotosState;
}

export const initialArticlesPhotosState: ArticlesPhotosState = {};

declare type ArticlesPhotosReducerAction =
    | ArticlePhotoFetchRequestAction
    | ArticlePhotoFetchSuccessAction
    | ArticlePhotoFetchFailureAction;

export const articlesPhotosReducer: Reducer<ArticlesPhotosState, ArticlesPhotosReducerAction> = (
    state = initialArticlesPhotosState,
    action,
) => {
    switch (action.type) {
        case ARTICLE_PHOTO_FETCH_REQUEST:
        case ARTICLE_PHOTO_FETCH_FAILURE: {
            const key = `${action.categorySlug}/${action.articleSlug}`;
            const articleState = state[key] || initialArticlePhotosState;
            return tupdate(state, {
                [key]: tupdate(articleState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(articleState.errorMessage, action),
                }),
            });
        }

        case ARTICLE_PHOTO_FETCH_SUCCESS: {
            const key = `${action.categorySlug}/${action.articleSlug}`;
            const articleState = state[key] || initialArticlePhotosState;
            return tupdate(state, {
                [key]: tupdate(articleState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                    articleId: action.response.result.article,
                    articlePhotoIds: getDenormalizedEntity<WikiArticleEntity>(
                        action.response,
                        WikiArticleSchema,
                        action.response.result.article,
                    ).photos.map((photo) => photo.id),
                }),
            });
        }

        default:
            return state;
    }
};
